// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"115":"0afa2bf9","507":"59cff2eb","787":"b8871196","947":"85ab745e"}[chunkId] + ".chunk.js";
};